import { component } from 'picoapp';
import iro from '@jaames/iro';
import namer from 'color-namer';
import getClient from './sanity';

export default component((node, ctx) => {
  const swatches = document.querySelectorAll('.js-custom-color');
  const header = document.querySelector('.js-header');

  const anchorLinks = node.querySelectorAll('.js-anchor-link');
  anchorLinks.forEach(link => {
    link.addEventListener('click', () => {
      const anchor = node.querySelector(link.dataset.anchor);
      if (anchor) {
        const isMobile = false;
        const block = isMobile ? 'start' : 'end';

        anchor.scrollIntoView({
          behavior: 'smooth',
          block: block,
          inline: 'nearest',
        });
      }
    });
  });

  const customMenu = node.querySelectorAll('.custom-menu-item');
  const setActiveMenu = (index = false) => {
    customMenu.forEach((menu, i) => {
      if (i === index) {
        menu.classList.add('is-active');
      } else {
        menu.classList.remove('is-active');
      }
    });
  };

  const sectionHeight = node.querySelector('.custom-height').offsetHeight;
  window.addEventListener('scroll', event => {
    const scrollTop = window.scrollY;

    if (scrollTop > 50) {
      header.classList.add('fade-out');
    } else {
      header.classList.remove('fade-out');
    }

    if (scrollTop > 0 && scrollTop < sectionHeight) {
      setActiveMenu();
    } else if (scrollTop >= sectionHeight * 3) {
      setActiveMenu(2);
    } else if (scrollTop >= sectionHeight * 2) {
      setActiveMenu(1);
    } else if (scrollTop >= sectionHeight) {
      setActiveMenu(0);
    }
  });

  const hexInput = node.querySelector('.hex-input');
  const reviewHex = node.querySelectorAll('.js-final-hex');
  const nameInput = node.querySelector('.js-name');
  const namePreview = document.querySelectorAll('.js-creation-name');
  const remaniningCharacters = node.querySelector('.js-characters');
  const saveButton = node.querySelector('.save-button');

  const urlParams = new URLSearchParams(window.location.search);

  const initialColour = urlParams.get('color')
    ? `#${urlParams.get('color')}`
    : '#FF5352';

  if (urlParams.get('name')) {
    nameInput.value = urlParams.get('name');
    if(namePreview) namePreview.forEach(elm =>{elm.textContent = urlParams.get('name')});
  }

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      if (urlParams.get('section')) {
        const sectionToScroll = document.getElementById(
          urlParams.get('section'),
        );
        if (sectionToScroll) {
          setTimeout(() => {
            const isMobile = false;
            const block = isMobile ? 'start' : 'end';

            sectionToScroll.scrollIntoView({
              behavior: 'smooth',
              block: block,
              inline: 'nearest',
            });
          }, 500);
        }
      }
    },
    false,
  );

  console.log('~~~~', urlParams.toString());

  swatches.forEach(swatch => {
    swatch.style.backgroundColor = initialColour;
  });
  reviewHex.forEach(element => {
    if (element.nodeName === 'INPUT') {
      element.value = initialColour;
    } else {
      element.textContent = initialColour;
    }
  });

  let colorPickerWidth = 600;
  if (window.innerWidth < 600) {
    colorPickerWidth = window.innerWidth - 40;
  } else if (window.innerHeight - 190 < 620) {
    colorPickerWidth = window.innerHeight - 190 - 20;
  }

  var colorPicker = new iro.ColorPicker('#picker', {
    width: colorPickerWidth,
    color: initialColour,
    wheelLightness: false,
    sliderSize: 10,
    margin: 10,
  });

  hexInput.addEventListener('input', function () {
    const isValid = CSS.supports('color', `#${this.value}`);
    if (isValid && this.value.length === 6) {
      colorPicker.color.hexString = `#${this.value}`;
    }
  });

  function isTooLightYIQ(hexcolor) {
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128;
  }

  function updateCustomProductsUrl(color) {
    document.querySelectorAll('[data-creation-url]').forEach(element => {
      const prodUrl = element.dataset.productUrl;
      const urlParameters = new URLSearchParams({
        name: nameInput.value,
        color: color ? color.replace('#', '') : hexInput.value,
      });
      const url = `${prodUrl}?${urlParameters}`;
      element.href = url;
    });
  }
  updateCustomProductsUrl(initialColour);

  colorPicker.on('color:change', function (color) {
    hexInput.value = color.hexString.replace('#', '');

    const reversed = !isTooLightYIQ(color.hexString.replace('#', ''));
    if (reversed) {
      hexInput.classList.add('is-reverse');
    } else {
      hexInput.classList.remove('is-reverse');
    }

    console.log('~', isTooLightYIQ(color.hexString.replace('#', '')));

    reviewHex.forEach(element => {
      if (element.nodeName === 'INPUT') {
        element.value = color.hexString.toUpperCase();
      } else {
        element.textContent = color.hexString.toUpperCase();
      }
    });

    swatches.forEach(swatch => {
      swatch.style.backgroundColor = color.hexString;
    });
    updateCustomProductsUrl();
    checkSaveButtonDisabledState();
  });

  nameInput.addEventListener('input', function () {
    console.log('this.value', this.value, this.value.length);

    remaniningCharacters.textContent = `${this.value.length}/15`;
    if (this.value.length >= 1) {
      // namePreview.textContent = this.value;
      namePreview.forEach(elm =>{elm.textContent = this.value});
    } else {
      // namePreview.textContent = 'Creation Name';
      namePreview.forEach(elm =>{elm.textContent = 'Creation Name'});
    }
    updateCustomProductsUrl();
    checkSaveButtonDisabledState();
  });

  function checkSaveButtonDisabledState() {
    const urlParams = new URLSearchParams(window.location.search);
    const name = urlParams.get('name');
    const color = urlParams.get('color');
    const saved = urlParams.get('saved');

    console.log('checkSaveButtonDisabledState', saved, typeof saved);

    if (name && color) {
      if (
        name === nameInput.value &&
        `#${color}` === colorPicker.color.hexString &&
        saved === 'true'
      ) {
        saveButton.classList.add('is-disabled');
      } else {
        saveButton.classList.remove('is-disabled');
      }
    } else {
      saveButton.classList.remove('is-disabled');
    }
  }
  checkSaveButtonDisabledState();

  const setNone = node.querySelectorAll('.js-set-none');
  setNone.forEach(element => {
    element.addEventListener('click', () => {
      const none = document.querySelector('input[value="None"');
      if (none) none.click();
    });
  });

  // const inputs = node.querySelector('input[type="radio"]');
  // inputs.forEach(input => {
  //   input.addEventListener('click', event => {
  //     console.log('click', event.target.value);
  //   });
  // });
  const radios = document.querySelector('variant-radios');
  const variantName = document.querySelector('.js-variant-name');
  if (radios) {
    radios.addEventListener('change', event => {
      const name = event.target.defaultValue.replace(' +$3', '');
      variantName.textContent = name;

      if (name !== 'None') {
        setNone.forEach(element => {
          element.classList.add('is-active');
        });
      } else {
        setNone.forEach(element => {
          element.classList.remove('is-active');
        });
      }
    });
  }

  const getRandomName = () => {
    const names = namer(colorPicker.color.hexString);
    const random = Math.floor(Math.random() * 15);
    return names.pantone[random].name;
  };

  const randomName = node.querySelector('.js-random-name');
  randomName.addEventListener('click', () => {
    const newName = getRandomName();

    remaniningCharacters.textContent = `${newName.length}/15`;
    nameInput.value = newName;
    // namePreview.textContent = newName;
    namePreview.forEach(elm =>{elm.textContent = newName});
    updateCustomProductsUrl();
    checkSaveButtonDisabledState();
  });

  const sectionButtons = node.querySelectorAll(
    '.color-nav .colour-option-button',
  );

  const changeSection = id => {
    const sections = node.querySelectorAll('.colour-section');
    sections.forEach(section => {
      section.classList.add('hidden');
    });
    sectionButtons.forEach(button => {
      console.log('button', button, button.dataset.section == id);
      if (button.dataset.section == id) {
        button.classList.add('is-active');
      } else {
        button.classList.remove('is-active');
      }
    });
    node.querySelector(`#${id}`).classList.remove('hidden');
  };

  sectionButtons.forEach(button => {
    button.addEventListener('click', event => {
      console.log('event', event);
      changeSection(event.target.dataset.section);
    });
  });

  function uploadedImage() {
    let img = _('.thumbnail img'),
      canvas = _('#cs'),
      result = _('.result'),
      preview = _('.preview'),
      x = '',
      y = '';
    console.log('uploadedImage');
    img.addEventListener(
      'click',
      function (e) {
        console.log('click', result);
        if (e.offsetX) {
          x = e.offsetX;
          y = e.offsetY;
        } else if (e.layerX) {
          x = e.layerX;
          y = e.layerY;
        }
        useCanvas(canvas, img, function () {
          var p = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
          const hex = rgbToHex(p[0], p[1], p[2]);
          colorPicker.color.hexString = hex;
        });
      },
      false,
    );
    // img.addEventListener(
    //   'mousemove',
    //   function (e) {
    //     console.log('mousemove');
    //     if (e.offsetX) {
    //       x = e.offsetX;
    //       y = e.offsetY;
    //     } else if (e.layerX) {
    //       x = e.layerX;
    //       y = e.layerY;
    //     }

    //     useCanvas(canvas, img, function () {
    //       var p = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
    //       const hex = rgbToHex(p[0], p[1], p[2]);
    //       colorPicker.color.hexString = hex;
    //     });
    //   },
    //   false,
    // );
    function useCanvas(el, image, callback) {
      el.width = image.width;
      el.height = image.height;
      el.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
      return callback();
    }
    function _(el) {
      return document.querySelector(el);
    }
    function componentToHex(c) {
      var hex = c.toString(16);
      return hex.length == 1 ? '0' + hex : hex;
    }
    function rgbToHex(r, g, b) {
      return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }
    function findPos(obj) {
      var curleft = 0,
        curtop = 0;
      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return { x: curleft, y: curtop };
      }
      return undefined;
    }
  }

  function encodeImageFileAsURL() {
    var filesSelected = document.getElementById('inputFileToLoad').files;
    if (filesSelected.length > 0) {
      var fileToLoad = filesSelected[0];

      var fileReader = new FileReader();

      fileReader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result; // <--- data: base64

        var newImage = document.createElement('img');
        newImage.src = srcData;

        document.getElementById('imgTest').innerHTML = newImage.outerHTML;

        console.log(
          'Converted Base64 version is ' +
            document.getElementById('imgTest').innerHTML,
        );
        uploadedImage();
      };
      fileReader.readAsDataURL(fileToLoad);
    }
  }

  const fileInput = document.getElementById('inputFileToLoad');

  document.querySelector('.js-upload-photo').addEventListener('click', () => {
    fileInput.click();
  });

  fileInput.addEventListener('change', () => {
    encodeImageFileAsURL();
  });

  const r = Math.round;
  const aSwatches = document.querySelectorAll('.a .swatch');
  const bSwatches = document.querySelectorAll('.b .swatch');
  const result = document.querySelector('.result');
  const pInput = document.querySelector('[data-p]');
  const aInput = document.querySelector('[data-a]');
  const bInput = document.querySelector('[data-b]');

  aSwatches.forEach(swatch => {
    swatch.addEventListener('click', event => {
      aInput.value = event.target.dataset.hex;
      update();
    });
  });

  bSwatches.forEach(swatch => {
    swatch.addEventListener('click', event => {
      bInput.value = event.target.dataset.hex;
      update();
    });
  });

  pInput.oninput = aInput.oninput = bInput.oninput = update;
  // update();

  function update() {
    const rgb = blend(aInput.value, bInput.value, Number(pInput.value));
    result.style.background = rgb;
    colorPicker.color.hexString = rgb;
  }

  function toRGBA(d) {
    const l = d.length;
    const rgba = {};
    if (d.slice(0, 3).toLowerCase() === 'rgb') {
      d = d.replace(' ', '').split(',');
      rgba[0] = parseInt(d[0].slice(d[3].toLowerCase() === 'a' ? 5 : 4), 10);
      rgba[1] = parseInt(d[1], 10);
      rgba[2] = parseInt(d[2], 10);
      rgba[3] = d[3] ? parseFloat(d[3]) : -1;
    } else {
      if (l < 6)
        d = parseInt(
          String(d[1]) +
            d[1] +
            d[2] +
            d[2] +
            d[3] +
            d[3] +
            (l > 4 ? String(d[4]) + d[4] : ''),
          16,
        );
      else d = parseInt(d.slice(1), 16);
      rgba[0] = (d >> 16) & 255;
      rgba[1] = (d >> 8) & 255;
      rgba[2] = d & 255;
      rgba[3] =
        l === 9 || l === 5 ? r((((d >> 24) & 255) / 255) * 10000) / 10000 : -1;
    }
    return rgba;
  }

  function blend(from, to, p = 0.5) {
    from = from.trim();
    to = to.trim();
    const b = p < 0;
    p = b ? p * -1 : p;
    const f = toRGBA(from);
    const t = toRGBA(to);
    if (to[0] === 'r') {
      return (
        'rgb' +
        (to[3] === 'a' ? 'a(' : '(') +
        r((t[0] - f[0]) * p + f[0]) +
        ',' +
        r((t[1] - f[1]) * p + f[1]) +
        ',' +
        r((t[2] - f[2]) * p + f[2]) +
        (f[3] < 0 && t[3] < 0
          ? ''
          : ',' +
            (f[3] > -1 && t[3] > -1
              ? r(((t[3] - f[3]) * p + f[3]) * 10000) / 10000
              : t[3] < 0
              ? f[3]
              : t[3])) +
        ')'
      );
    }

    return (
      '#' +
      (
        0x100000000 +
        (f[3] > -1 && t[3] > -1
          ? r(((t[3] - f[3]) * p + f[3]) * 255)
          : t[3] > -1
          ? r(t[3] * 255)
          : f[3] > -1
          ? r(f[3] * 255)
          : 255) *
          0x1000000 +
        r((t[0] - f[0]) * p + f[0]) * 0x10000 +
        r((t[1] - f[1]) * p + f[1]) * 0x100 +
        r((t[2] - f[2]) * p + f[2])
      )
        .toString(16)
        .slice(f[3] > -1 || t[3] > -1 ? 1 : 3)
    );
  }

  saveButton.addEventListener('click', async () => {
    if (!nameInput.value) {
      nameInput.focus();
      return;
    }

    saveButton.classList.add('loading');

    let url = `${window.location.pathname}${window.location.search}`;
    if (url.includes('&name')) {
      const split = url.split('&name');
      url = split[0];
    }

    const creation = {
      _type: 'creation',
      identifier: saveButton.dataset.email.replace(/[^a-zA-Z0-9]/g, '_'),
      name: nameInput.value,
      fragrance: variantName ? variantName.textContent : null,
      color: {
        _type: 'color',
        hex: colorPicker.color.hexString,
      },
      hex: colorPicker.color.hexString,
      type: saveButton.dataset.type,
      createdBy: saveButton.dataset.customerLastName,
      createdByFirstName: saveButton.dataset.customerFirstName,
      url: url,
    };

    const client = await getClient();
    console.log('~', creation);

    client.create(creation).then(res => {
      console.log(`Creation success, document ID is ${res._id}`);
      saveButton.classList.remove('loading');
      saveButton.querySelector('.subheading-2').textContent = 'Saved';
      saveButton.style.pointerEvents = 'none';
    });
  });
});
